import getConfig from "next/config"

const { publicRuntimeConfig: config } = getConfig()
const assetPrefix = config.assetPrefix

export default assetPrefix
